import { UIDialog } from './dialog';
import { UIHLSPlayer } from './hls-player';

export class UIVideoDialog extends UIDialog {
    constructor(url: string) {
        super({ classes: 'ui-video-dialog', tap_close: true });
        this.content.ui_add(new UIHLSPlayer(url, true));
    }
}
